/**
 * Created by tomers on 9/1/2014.
 * This is the default header view
 * For internal use of page component only. if you import this from out side I will @#$ you
 */
define(function (require) {
    "use strict";


    var $ = require("jquery");
    var _ = require("underscore");
    var Marionette = require("marionette");

    var SelectableCollectionDecorator = require("decorators/SelectableCollectionDecorator");
    var TabsBar = require("ui/tabsbar/TabsBar");

    var template = require("ui/page/templates/pageHeaderView.tmpl");

    var PageHeaderView = Marionette.ItemView.extend({
        template: template,
        withUIComponents: true,
        ui: {
            title: ".page-title .title-content",
            description: ".page-description .description-content"
        },
        initialize: function(options) {
            this.moduleName = options.moduleName;
            this.context = options.context;

            this.title = options.title;
            this.description = options.description;
            this.feedback = options.feedback;
            this.beta = options.beta;
            this.dependency = options.dependency;
        },
        onRender: function() {
            this.updateTitle();
            this.updateDescription();
            this.updateFeedback();
            this.updateBeta();
        },
        updateTitle: function() {
            if (_.isString(this.title)) {
                this._resetTitle();
                this.ui.title.text(this.title);
            }
            else if(_.isObject(this.title)) {
                if (this.title.tabs) { // used to set the tabs in the header
                    this._resetTitle();
                    if (this.title.tabs.length > 1) {
                        var tabsBarCollection = new TabsBar.TabCollection(this.title.tabs);
                        this.titleTabsCollection = SelectableCollectionDecorator.decorate(tabsBarCollection, this.title.selectedTabId);
                        this.uiComponents.host$.createAndRender("titleTabs", {
                            type: TabsBar,
                            options: {
                                el: "view.ui.title",
                                permutation: TabsBar.PERMUTATION.C,
                                commitStateChange: false,
                                collection: "view.titleTabsCollection"
                            },
                            events: {
                                "change:selection": "_onHeaderTabsChange"
                            }
                        });
                    }
                    else if (this.title.tabs.length > 0) {
                        this.ui.title.text(this.title.tabs[0].name);
                    }
                }
                else if (this.title.selectedTabId) { // used to set the selected tab. in this case you should do: pageView.setTitle({selectedTabId: X});
                    if (this.uiComponents.titleTabs) {
                        this.titleTabsCollection.selectModel(this.title.selectedTabId);
                    }
                }
            }
        },
        _resetTitle: function() {
            if (this.uiComponents && this.uiComponents.titleTabs) {
                this.uiComponents.titleTabs.close();
            }
            this.ui.title.empty();
        },
        _onHeaderTabsChange: function(componentName, eventName, selectedTabId) {
            this.trigger("headerTabsChange", selectedTabId);
        },

        updateDescription: function() {
            this.ui.description.html(this.description); //allows breakline support
        },
        updateFeedback: function() {

        },
        updateBeta: function() {

        },
        setTitle: function(title) {
            this.title = title;
            this.updateTitle();
        },
        setDescription: function(description) {
            this.description = description;
            this.updateDescription();
        },
        setFeedback: function(feedback) {
            this.feedback = feedback;
            this.updateFeedback();
        },
        setBeta: function(beta) {
            this.beta = beta;
            this.updateBeta();
        }
    });

    return PageHeaderView;
});

